import styled from "styled-components";

export const Styles = styled.div`
    .about-page {
        .aboutus-area {
            padding-top: 80px;

            @media only screen and (max-width: 767px) {
                padding-top: 40px;
            }
        }
    }
`;